import Filter from "./Filter";
import FormData from "./FormData";
import FormUsers from "./FormUsers";
import ListData from "./ListData";
import TableData from "./TableData";
import NoGroup from "./NoGroup";

const groupsComponents = {
  Filter,
  FormData,
  FormUsers,
  ListData,
  TableData,
  NoGroup
}

export default groupsComponents